// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"281":"ab8281b6","453":"0cf1f205","834":"3a98f66d"}[chunkId] + ".chunk.js";
};